import { ReactComponent as TierAwardSvg } from "../../../../assets/images/tier-award.svg";

export function TierAwardImage() {
  return (
    <div>
      <TierAwardSvg />
    </div>
  );
}